import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieConsentBanner from "./components/CookieConsetBanner";
import AiChatAssistant from "./components/AiChatAssistant";

const Careers = lazy(() => import("./pages/Careers"));
const Home = lazy(() => import("./pages/Home"));
const Insights = lazy(() => import("./pages/Insights"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Services = lazy(() => import("./pages/Services"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const PrivacyPolicy = lazy(() => import("./components/PrivacyPolicy"));
const ApplyNow = lazy(() => import("./pages/ApplyNow"));
const TeamProfile = lazy(() => import("./pages/TeamProfile"));
const Products = lazy(() => import("./pages/Products"));

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#0F1B3D', color: '#fff' }}>
    Loading...
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Navbar />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/services" element={<Services/>}/>
            <Route path="/about" element={<AboutUs />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/apply" element={<ApplyNow />} />
            <Route path="/team/:id" element={<TeamProfile />} />
            <Route path="/products" element={<Products />} />
          </Routes>
        </Suspense>
        <CookieConsentBanner/>
        <AiChatAssistant />
        <Footer/>
      </Router>
    </HelmetProvider>
  );
}

export default App;
